import axiosInstance from "./axios";

export class BuzonDudasService {
    getPreguntasByFecha(fecha) {
        return axiosInstance
            .get(`/preguntas/getbyfecha`, { params: { fecha } })
            .then((res) => res.data)
    }

    getPregunta(id) {
        return axiosInstance
            .get(`/preguntas/${id}`)
            .then((res) => res.data)
    }

    addRespuesta(idpregunta, dto) {
        return axiosInstance
            .post(`/preguntas/respuesta/${idpregunta}`, dto)
            .then((res) => res.data)
    }

    updateRespuesta(idpregunta, idrespuesta, dto) {
        return axiosInstance
            .put(`/preguntas/respuesta/${idpregunta}/${idrespuesta}`, dto)
            .then((res) => res.data)
    }

    deletePregunta(id) {
        return axiosInstance
            .delete(`/preguntas/${id}`)
            .then((res) => res.data)
    }
}
